import { Section } from "@models/ISchema";
import { classifySessionLockState } from "./classifySessionLockState";

export const isSectionFullyPastBlocked = (
  section: Section,
  thresholdDate: string | null,
  canEditPastSessions: boolean,
): boolean => {
  if (canEditPastSessions || !thresholdDate) return false;

  const assignedSessions = section?.sessions ?? [];
  const unassignedSessions = section?.unasignedSessions ?? [];

  if (assignedSessions.length === 0) return false;
  if (unassignedSessions.length > 0) return false;

  return assignedSessions.every(
    session => classifySessionLockState(session, thresholdDate, canEditPastSessions) === "all",
  );
};
